import React, { useState } from 'react'
import User1 from "../../assets/images/Testimonial1.jpg"

const TeamCard = ({ name, position, i, key , image }) => {
    const [active, setActive] = useState('')    
    return (

        <div className='mx-3 mt-5' key={i+"team"}>
            <div className="team-item-wrap">
                <div className={`team-inner-wrap ${active == i ? "current-share" : ""}`}>
                    <div className="image-wrap">
                        <div className="image-inner">
                            <a>
                                <img src={image} alt="Team" />
                            </a>
                        </div>
                    </div>
                    <div className="team-content">
                        <div className="member-desc">
                            <h3 className="team-name">
                                {name}
                            </h3>
                            <span className="team-title">{position}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}

export default TeamCard